import React, { FC } from "react";
import Drawer from "shared/components/Drawer";
import Tabs from "./components/Tabs";
import General from "./components/Tabs/Content/General";
import Translations from "./components/Tabs/Content/Translations";
import { MetadataTagDetailsProvider, useMetadataTagDetails } from "./context";
import { MetadataTagDetailsTabs } from "./context/types";
import MetadataTagDetailsSkeleton from "./skeleton";
import ActionButton from "./components/ActionButton";
import { useMetadataTagsPage } from "../../context";

const MetadataTagDetailsContainer: FC = () => (
  <MetadataTagDetailsProvider>
    <MetadataTagDetails/>
  </MetadataTagDetailsProvider>
);

const MetadataTagDetails: FC = () => {
  const { metadataTagDetailsDrawer } = useMetadataTagsPage();
  const {
    metadataTagTitle,
    selectedTab,
    loading,
    onCloseTagDetails,
  } = useMetadataTagDetails();

  const TAB_CONTENT: Record<MetadataTagDetailsTabs, FC> = {
    [MetadataTagDetailsTabs.General]: General,
    [MetadataTagDetailsTabs.Translations]: Translations,
  };
  const ContentComponent = TAB_CONTENT[selectedTab];

  return (
    <Drawer
      title={metadataTagTitle}
      isOpen={metadataTagDetailsDrawer.isOpen}
      onCloseDrawer={onCloseTagDetails}
      headingRight={<ActionButton/>}
      headingBottom={<Tabs/>}
    >
      {loading && <MetadataTagDetailsSkeleton />}
      {!loading && <ContentComponent />}
    </Drawer>
  );
};

export default MetadataTagDetailsContainer;
